import React from "react";
import { components } from "react-select";
import "./checkbox-option.scss";

const CheckboxOption = props => {
  const { isSelected, label } = props;
  return (
    <div>
      <components.Option {...props}>
        {/* <input
          type="checkbox"
          checked={isSelected}
          onChange={() => null}
          name="checkbox-option"
        />
        <label className="ml-2" htmlFor="checkbox-option">
          {label}
        </label> */}

        <label className="checkbox-option" htmlFor="checkbox-option">
          {label}
          <input
            type="checkbox"
            onChange={() => null}
            name="checkbox-option"
            checked={isSelected}
          />
          <span className="option-checkmark ltr:left-0 rtl:right-0" />
        </label>
      </components.Option>
    </div>
  );
};

export default CheckboxOption;
